export const GROUP_PREMIUM_EXPORTS_REPORT = 'GROUP_PREMIUM_EXPORTS_REPORT';
export const PAY_PERIOD_PREMIUM_EXPORTS_REPORT =
  'PAY_PERIOD_PREMIUM_EXPORTS_REPORT';
export const DEFAULT_REPORT_NAME = 'premiums_export';
export const DEFAULT_ITEMS_PER_PAGE = 10;
